<template>
    <div>
        <b-row>
            <b-col md="12">
                    <b-card>
                        <b-row>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('faculty_code')">
                                    {{ formData.faculty_code }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('department_code')">
                                    {{ formData.department_code }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('program_code')">
                                    {{ formData.code }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('program_name')">
                                    {{ getLocaleText(formData, 'name') }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('program_level')">
                                    {{ getLocaleText(formData, 'level_text') }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('program_language')">
                                    {{ formData.language }}
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4">
                                <b-form-group :label="$t('program_duration')">
                                    {{ formData.duration }}
                                </b-form-group>
                            </b-col>
                        </b-row>

                    </b-card>
                </b-col>
        </b-row>
        <b-row>
            <b-col md="12" class="mt-2">
                <b-card>
                    <b-row>
                        <b-col md="12" v-for="(tblData, key) in tableData" :key="key">
                            <b-table
                                :empty-filtered-text="$t('no_result')"
                                :empty-text="$t('no_result')"
                                bordered
                                striped
                                responsive
                                :items="tblData"
                                :fields="tableFields"
                                show-empty
                                caption-top
                                class="mb-5 mt-2 table-dropdown no-scrollbar border rounded">
                                <template #thead-top>
                                    <b-tr>
                                        <b-th class="bg-primary text-white" colspan="9">{{ (key+1)+'. '+$t('period') }}</b-th>
                                    </b-tr>
                                </template>
                                <template #cell(buttons)="row">
                                    <b-dropdown variant="link btn-sm" boundary="window" no-caret v-if="['T','R','NK','N','G','F','D','C'].includes(row.item.slot_type)">
                                        <template #button-content>
                                            <i class="ri-more-fill"></i>
                                        </template>
                                        <div id="dropdownListHead">
                                            <b-dropdown-item @click="openElectiveBox(row.item)" v-if="checkPermission('ects_programcoordinatorelectivecourses')">
                                                <i class="ri-stack-line align-middle top-minus-1 mr-3 text-muted"></i> {{$t('elective_courses')}}
                                            </b-dropdown-item>
                                        </div>
                                    </b-dropdown>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
// Components

// Services
import EctsService from "@/services/EctsService"


// Other

export default {
    components: {
    },
    props: {
        program: {
            type: Object,
        },
    },
    data() {
        return {
            formLoading: false,
            formData: {},
            tableData: [],
            tableFields: [
                {
                    key: 'buttons',
                    label: ''
                },
                {
                    key: 'course.code',
                    label: this.$t('course_code')
                },
                {
                    key: this.getLocaleField('course.name'),
                    label: this.$t('course_name')
                },
                {
                    key: 'course.language',
                    label: this.$t('language')
                },
                {
                    key: this.getLocaleField('slot_type_name'),
                    label: this.$t('slot_type')
                },
                {
                    key: 'course.theoretical_credit',
                    label: this.$t('theoretical')
                },
                {
                    key: 'course.practical_credit',
                    label: this.$t('practical')
                },
                {
                    key: 'course.credit',
                    label: this.$t('credit')
                },
                {
                    key: 'course.ects_credit',
                    label: this.$t('ects')
                },
            ],
            isNew: false,
            newFormData: {},
            isDefinition: true,
            definitionForm: {}
        };
    },
    created() {
        this.formData = this.program
        this.getData()
    },
    methods: {
        getData(){
            EctsService.getProgramCoordinatorCurriculum().then(response => {
                this.tableData = response.data.data
            }).catch(e => {
                this.showErrors(e)
            })
        },

        openElectiveBox(data){
            let newData = {
                course_name: this.$t("elective_courses"),
                code: '',
                data: data
            }
            this.$emit('openCourseDetail', newData, 'elective-courses')
        }

    },
}
</script>
